import Vue from 'vue'
import loading from 'vuejs-loading-screen'

Vue.use(loading)